import Seo from "./Seo";
import { buildAudioDescription, buildAudioJsonLd, buildAudioKeywords } from "../utils/audioSeo";

type AudioType = "audios" | "pravachans" | "DailySatsang";

type AudioSeoProps = {
  audio: any;
  canonicalPath: string;
  type: AudioType;
};

const AudioSeo = ({ audio, canonicalPath, type }: AudioSeoProps) => {
  if (!audio) return null;

  const title = audio?.pageTitle || audio?.ogTitle || (audio?.name ? `${audio.name} | Gita Seva` : "Gita Seva Audio");
  const description = audio?.pageDescription || audio?.ogDescription || buildAudioDescription(audio, type);
  const keywords = buildAudioKeywords(audio, type);
  // Use ogImage only - it is the dedicated OG image, different from audio thumbnail
  const image = audio?.ogImage || "";
  const jsonLd = buildAudioJsonLd(audio, canonicalPath, type);

  const ogType = type === "pravachans" ? "pravachan" : type === "DailySatsang" ? "dainik satsang" : "audio";

  return (
    <Seo
      title={title}
      description={description}
      keywords={keywords}
      path={canonicalPath}
      image={image}
      ogImageWidth={1200}
      ogImageHeight={630}
      ogType={ogType}
      robots="index,follow"
      jsonLd={jsonLd}
    />
  );
};

export default AudioSeo;
